import { FLAW_OPTIONS } from '../FLAW_OPTIONS';
import { FlawOptionIdType } from '../types';

export const getFlawTitleById = (
  id: FlawOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return FLAW_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: FlawOptionIdType = 'jealous';
export const getFlawIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): FlawOptionIdType | null => {
  const id = FLAW_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
